import React from 'react';

const Logo = () => {
  return (
    <div className="logo-container">
      <span className="logo-first">SIDDHARTH</span>
      <span className="logo-last">Kr</span>
    </div>
  );
};

export default Logo;